import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
const HorizontalColumnSpacing = css `
  padding-left: ${(props) => pxToRem(props.$spacing * 4)};
`;
const VerticalColumnSpacing = css `
  padding-top: ${(props) => pxToRem(props.$spacing * 4)};
`;
export const ColumnContainer = styled.div `
  box-sizing: border-box;
  ${(props) => props.$horizontal && HorizontalColumnSpacing}
  ${(props) => props.$vertical && VerticalColumnSpacing}
`;
const HorizontalGridSpacing = css `
  margin-left: ${(props) => pxToRem(props.$spacing * -4)};
`;
const VerticalGridSpacing = css `
  margin-top: ${(props) => pxToRem(props.$spacing * -4)};
`;
export const GridContainer = styled.div `
  display: flex;
  flex-flow: row wrap;
  ${(props) => props.$horizontal && HorizontalGridSpacing}
  ${(props) => props.$vertical && VerticalGridSpacing}
`;
